/* eslint-disable no-shadow */
/* eslint-disable eqeqeq */
import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

const UserPermitsUnits = ({
  units = [],
  unitsUser = [],
  user = {},
  onDeleteUnit,
  onUpdateUnit,
}) => {

  const canUse = (userPermissions, permission) => {
    let canUse = false;
    // eslint-disable-next-line prefer-destructuring
    canUse = userPermissions
      .filter((userPermission) => userPermission.unidad_negocio_id == permission.id)[0];
    // return Boolean(canUse);
    return canUse ? canUse.id : 0;

  };

  const handleChangeCheck = (event) => {
    event.preventDefault()
    const unitId = event.target.value
    const idUnit = event.target.id
    if (event.target.checked === false) {
      onDeleteUnit({
        'unidad_negocio_id': unitId,
      })
    } else {
      onUpdateUnit({
        'usuario_id': user.id,
        'unidad_negocio_id': idUnit,
      })
    }
  }

  return (
    <div>
      {
        Array.isArray(units) ? units.map((permitList) => {
          const userPermissionLevel = canUse(unitsUser, permitList)
          return (
            <FormControlLabel
              key={permitList.id}
              control={(
                <Switch
                  id={`${permitList.id}`}
                  checked={!!userPermissionLevel}
                  onChange={(event) => handleChangeCheck(event)}
                  value={userPermissionLevel}
                />
              )}
              label={permitList.unidad}
              labelPlacement='bottom'
            />
          )
        }) : <p>...Cargando Permisos</p>
      }
    </div>
  )
}

export default UserPermitsUnits
